import React, { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Curve,
  CurveOverImage,
  Phone,
  Time as TimeIcon,
  VoiceIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
  MainHolder,
  Children,
  Body,
  NotesContainer,
  CircleContainer,
  Dot,
  FooterImageContainer,
  FooterImage,
  FooterContainer,
  TipsContainer,
  TipContainer,
  Divider,
} from "../../../components/common/basic";
import CountdownTimer from "./components/CountdownTimer";
import { BackButton, FeatureHeader } from "../../../components/common";
import usePulseNChillHome from "./hooks/usePulseNChillHome";
import MashupNowButton from "../mashupnwin/components/MashupNowButton";
import styled from "styled-components";

const now = new Date().getTime();
const PulseNChillHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "PulseAndChillHome",
        firebase_screen_class: "PulseAndChillHome",
      })
    );
  }, []);

  const { background, history, bannerImage, tailImage, tips, note } =
    usePulseNChillHome();

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={bannerImage}
            buttonText="My Points"
            title={["MTN Pulse", "& Chill Promo"]}
            onClick={() => history.push("pulsenchill/points")}
            background={background}
            secondaryBackground={"#fff"}
          >
            <CountdownTimer
              timeRemaining={300000 * 6}
              startTime={now}
              background={background}
              timeRunningContent={"to win amazing prizes 🎉'"}
              timeUpContent={"Ready to chill 🎉'"}
            />
          </FeatureHeader>

          <Body>
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNRegularItalic", margin: "0 0 24px 0" }}
              >
                <Span style={{ fontFamily: "MTNBoldItalic" }}>{`Yello`}</Span>
                {" Peeps!"}
              </StyledText>

              <StyledText
                letterSpacing={-0.38}
                height={17}
                style={{ fontFamily: "MTNRegular" }}
                size={13}
              >
                The MTN Pulse and chill promo is back. From 1st September to
                31th October 2022, simply mashup on myMTN App and you could be a
                proud winner of a whopping Ghc5,000 cash, shopping vouchers, up
                to 3GB data and many more prizes.
              </StyledText>

              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium", marginTop: "55px" }}
              >{`Things to note:`}</StyledText>

              {note.map((note, index) => {
                return (
                  <NotesContainer key={index}>
                    <CircleContainer>
                      <Dot color={background} />
                    </CircleContainer>
                    <StyledText
                      size={13}
                      style={{ fontFamily: "MTNRegular", marginBlockStart: 0 }}
                    >
                      {note}
                    </StyledText>
                  </NotesContainer>
                );
              })}
              <NotesContainer
                onClick={() => {
                  history.push("/pulsenchill/terms");
                }}
              >
                <CircleContainer>
                  <Dot color={background} />
                </CircleContainer>
                <StyledText
                  color={background}
                  size={13}
                  style={{
                    cursor: "pointer",
                    fontFamily: "MTNBold",
                    marginBlockStart: 0,
                    textDecoration: "underline",
                  }}
                >
                  {"Terms & Conditions"}
                </StyledText>
              </NotesContainer>

              <MashupButtonContainer>
                <MashupNowButton />
              </MashupButtonContainer>
            </div>
          </Body>
          {/* <CurveOverImage
            style={{ position: "relative", zIndex: 1, marginTop: -10, width: '100%' }}
            fill={"white"}
          /> */}
          <FooterImageContainer>
            <FooterImage src={tailImage} />
          </FooterImageContainer>
          {/* <CurveHolder style={{ position: "relative", zIndex: 1 }}>
            <Curve fill={background} />
          </CurveHolder> */}
          <FooterContainer activeTheme={background}>
            <StyledText size={24} color={"white"} style={{ marginTop: 0 }}>
              Here's some tips
            </StyledText>
            <TipsContainer>
              {tips.map((tip, index) => {
                const icons = [
                  <TimeIcon width={25} height={25} />,
                  <VoiceIcon width={25} height={25} fill={"black"} />,
                  <Phone width={25} height={25} />,
                ];
                return (
                  <TipContainer key={index}>
                    {icons[index]}
                    <Divider />
                    <StyledText
                      size={11}
                      color={"black"}
                      style={{ marginTop: "6px" }}
                    >
                      {tip}
                    </StyledText>
                  </TipContainer>
                );
              })}
            </TipsContainer>
            <Button
              style={{ margin: "35px 0" }}
              onClick={() => {
                history.push("/pulsenchill/faq");
              }}
              color={"white"}
            >
              <StyledText color={"black"}>
                {"Frequently asked questions"}
              </StyledText>
            </Button>
          </FooterContainer>
        </Children>
      </MainHolder>
    </>
  );
};

export default PulseNChillHome;

const MashupButtonContainer = styled.div`
  // display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 40px;
`;
